import React, { lazy } from "react"
import { Navigate } from "react-router"

import Loader from "../components/Common/Loader/loader"
import LoginLayout from "../layout/LoginLayout"
import MainLayout from "../layout/MainLayout"
import { PageLayout } from "../layout/PageLayout"
import { internalUserPages } from "../utils/Constant"
import menu from "./../utils/menuConfig.json"
import ErrorBoundaryPage from "../pages/ErrorBoundary"

const Home  = lazy(() => import( "../pages/Home"))
const Dashboard = lazy(() => import( "../pages/Dashboard"))
const ReviewOrder = lazy(() => import( "../pages/Order/CartOverview/ReviewOrder"))
const ReviewOrderSecondarySC = lazy(() => import( "../pages/Order/CartOverview/ReviewOrderSecondarySC"))
const Calculate = lazy(() => import( "../pages/pricing/Calculate"))
const ListPriceUpload = lazy(() => import( "../pages/pricing/ListPriceUpload"))
const OriginalNOS = lazy(() => import( "../pages/pricing/OriginalNOS"))

const TypeNumber = lazy(() => import( "../pages/TypeNumber"))
const ActionCode = lazy(() => import("../pages/ActionCode"))
const AssociatePartsToType = lazy(() => import("../pages/AssociatePartsToType"))
const ServiceMaterialActionCodeTypeNumberAssociation = lazy(() => import("../pages/SMActionCodeTypeNumberAssociation"))
const HubList = lazy(() => import("../components/Hub"))
const FinishedGoods = lazy(() => import("../pages/FinishedGoods"))
const CreateFinishedGoods = lazy(() => import("../pages/FinishedGoods/CreateFinishedGoods"))
const EditFinishedGoods = lazy(() => import("../pages/FinishedGoods/EditFinishedGoods"))
const WarrantyManagement = lazy(() => import("../pages/WarrantyManagement/index"))
const UnfaulityWarranty = lazy(() => import("../pages/WarrantyManagement/UnfaulityWarranty/index"))
const PgUserTicketsDetail = lazy(() => import("../pages/WarrantyManagement/WarrantyPgUserDetailsTicket/index"))
const AutoApprovalRules = lazy(() => import("../pages/WarrantyManagement/AutoApprovalRules"))
const AddEditAutoApprovalRules = lazy(() => import("../pages/WarrantyManagement/AutoApprovalRules/AddEditAutoApprovalRules"))
const InvoiceByCustomerNo = lazy(() => import("../pages/WarrantyManagement/PerformaInvoicing/InvoiceByCustomerNo"))
const InvoiceHistory = lazy(() => import("../pages/WarrantyManagement/PerformaInvoicing/InvoiceHistory"))
const OrderManagement = lazy(() => import("../pages/Order"))
const OrderDetail = lazy(() => import("../pages/Order/OrderList/OrderDetail"))
const SAPFeedBack = lazy(() => import("../pages/Order/OrderList/SAPFeedBack"))
const OrderClaimForm = lazy(() => import("../pages/Order/OrderClaimForm"))
const HubRegList = lazy(() => import("../components/HubRegionalContinents"))
const HubSubList = lazy(() => import("../components/HubSubcontinent"))
const HubCountry = lazy(() => import("../components/HubCountry"))
const OrderMinMaxQty = lazy(() => import("../components/OrderMinMaxQty"))
const SalesOrg = lazy(() => import("../components/SalesOrg"))
const PageNotFound = lazy(() => import("../pages/pageNotFound"))
const WorkListApproval = lazy(() => import("../pages/WorkListApprovals"))
const PsIndicator = lazy(() => import("../pages/PsIndicator"))
const ExceptionApprovers = lazy(() => import("../pages/ExceptionApprovers"))
const FailureCodeMap = lazy(() => import("../pages/FailureCodeMap"))
const PriceList = lazy(() => import("../pages/pricing/PriceList"))
const PriceMatrix = lazy(() => import("../pages/pricing/PriceMatrix"))
const MonthlyBookingRate = lazy(() => import("../pages/MonthlyBookingRate"))
const FirmRate = lazy(() => import("../pages/FirmRate"))
const PriceMatrixException = lazy(() => import("../pages/pricing/PriceMatrixException"))
const PriceDrivation = lazy(()=> import("../pages/pricing/PriceDerivation"))
const LumsumPrice = lazy(()=> import("../pages/LumsumPrice"))
const MasterDataMappingTMC = lazy(() => import("../pages/MasterDataMappingTMC"))
const ExchangeRate = lazy(() => import("../pages/ExchangeRate"))
const ExceptionsCode = lazy(() => import("../pages/ExceptionsCode"))
const ProductFrom = lazy(() => import("../pages/ProductFrom"))
const StaticReport = lazy(() => import("../pages/StaticReports/index"))
const CountryConfiguration = lazy(() =>
    import("../pages/CountryConfiguration")
)
const GgIndicator = lazy(() => import("../pages/GgIndicator"))
const FailureCodeMappedTypeNumber = lazy(() =>
    import("../pages/FailureCodeMappedTypeNumber")
)
const RegistrationRequest = lazy(() => import("../pages/RegistrationRequest"))

const ManageUsers = lazy(() => import("../pages/ManageUsers"))
const Training = lazy(() => import("../pages/Trainings"))
const ScheduleTraining = lazy(() => import("../pages/ScheduleTraining"))
const TrainingDetails = lazy(() =>
    import("../pages/Trainings/TrainingDetails")
)
const Login = lazy(() => import("../pages/Login"))
const SetPassword = lazy(() => import("../pages/Login/SetPassword"))

const PrimaryServiceCenter = lazy(() => import("../pages/ServiceNetwork"))
const AddNewServiceCenter = lazy(() =>
    import("../pages/ServiceNetwork/AddServiceCenter")
)
const EditServiceCenterAddress = lazy(() =>
    import("../pages/ServiceNetwork/EditServiceCenter")
)

const RolesAndPermission = lazy(() => import("../pages/RolesPermission"))
const CreateTypeNumber = lazy(() =>
    import("../pages/TypeNumber/CreateTypeNumber")
)
const EditTypeNumber = lazy(() =>
    import("../pages/TypeNumber/EditTypeNumber")
)
const Parts = lazy(() => import("../pages/parts"))
const CreatePart = lazy(() =>
    import("../pages/parts/CreateParts")
)
const FGAssociationWithCountry = lazy(() => import("../pages/FGCountryAssociation"))
const RegulatoryDocument = lazy(() => import("../pages/RegulatoryDocument"))
const RegulatoryDocumentDetails = lazy(() => import("../pages/RegulatoryDocument/Details/index"))
const GeneralExtraInstruction = lazy(() => import("../pages/InstructionPage/GeneralExtraInstruction"))
const GeneralExtraInstructionDocumentDetails = lazy(() => import("../pages/InstructionPage/Details/index"))
const PFPDetailedReportPage = lazy(() => import("../pages/PFPReport/PFPDetailedReport"))
const DeviceRegistration = lazy(() => import("../pages/WarrantyManagement/DeviceRegistration"))
const NOSMaterials= lazy(() => import("../pages/NOSMaterials"))


// Login Token from Local Storage;
const EditPart = lazy(() =>
    import("../pages/parts/EditPart")
)

const NewsAndBulletin = lazy(() => import("../pages/NewsBulletin"))
const NewsAndBulletinDetail = lazy(() => import("../pages/NewsBulletin/DetailsPage"))
const BlockTypeNoBulletin = lazy(() => import("../pages/BlockTypeNoBulletin"))
const ProductCatalogue = lazy(() => import("../pages/ProdutCatalogue"))
const ProductCatalogueCategories = lazy(() => import("../pages/ProdutCatalogue/Categories"))
const ProductAdvanceSearch = lazy(() => import("../pages/ProdutCatalogue/ProductAdvanceSearch"))
const ProductSearchResult = lazy(() => import("../pages/ProdutCatalogue/ProductSearchResult"))
const ServiceMaterialAssociation = lazy(() => import("../pages/SerivceMaterialAssociation"))
const ComplaintsWithoutTechnicalDefects = lazy(() => import("../pages/ComplaintsWithoutTechnicalDefects"))
const AllowedMaterials = lazy(() => import("../pages/AllowedMaterials"))
const BlockMaintenance = lazy(() => import("../pages/BlockMaintenance"))
const RejectMaintenance = lazy(() => import("../pages/RejectMaintenance"))
const ProductTypeInstructions = lazy(() => import("../pages/ProdutCatalogue/ProductTypeInstructions"))
const AssociateFgToParts = lazy(() => import("../pages/AssociateFgToParts"))
const AssociatePartsToFg = lazy(() => import("../pages/AssociatePartsToFg"))
const ParcelCondition = lazy(() => import("../pages/ParcelCondition"))
const ParcelContentStatus = lazy(() => import("../pages/ParcelContentStatus"))
const RetailerName = lazy(() => import("../pages/RetailerName"))
const CountryAttributeConfig = lazy(() =>
    import("../pages/CountryAttributeConfig")
)

const ArticleSeries = lazy(() =>
    import("../pages/ArticleSeries")
)

const ManualProductLifecycleStatus = lazy(() =>
    import("../pages/ProductLifecycleStatus")
)

const InventoryStatus = lazy(() =>
    import("../pages/InventoryStatus")
)

const NOSTMC = lazy(() => import("../pages/NosTMC"))

const EditTicket = lazy(()=> import("../pages/WarrantyManagement/EditTicket"))
const ListPriceforNosCorrection = lazy(()=> import("../pages/pricing/ListPriceforNosCorrection"))
const WarrantyPolicy = lazy(()=> import("../pages/WarrantyPolicy"))
const TypeOfRepair = lazy(() => import("../pages/TypeOfRepair"))
const ReasonForImpossibility = lazy(() => import("../pages/ReasonForImpossibility"))
const SampleCollection = lazy(()=> import("../pages/SampleCollection"))
const ReviewOrderUpload = lazy(()=> import("../pages/Order/OrderUpload/ReviewOrderUpload"))
const CreatePerformanceConfig = lazy(() => import("../pages/PayForPerformancePMC/CreatePerformanceConfig"))
const EditPerformanceConfig = lazy(() => import("../pages/PayForPerformancePMC/EditPerformanceConfig"))
const PayForPerformancePMC = lazy(() => import("../pages/PayForPerformancePMC"))
const PayForPerformanceReport = lazy(() => import("../pages/PFPReport/PayForPerformanceReport"))
const ServiceCenterFactSheet = lazy(() => import("../pages/ServiceCenterFactSheet"))
//const OrderUpload = lazy(()=> import("../pages/Order/OrderUpload")) 

// Login Token from Local Storage;
const loginDetails = sessionStorage.getItem("loginDetails") || null
const userDetails = sessionStorage.getItem("userDetails") || null // USer Details
let isTokenExist
let userType = null
if (loginDetails) {
    const parseData = JSON.parse(loginDetails)
    isTokenExist = parseData?.access_token || parseData?.mfaTokenData?.access_token || sessionStorage.getItem("id_token")
    userType = userDetails ? JSON.parse(userDetails)?.user_details?.user_type : 0
}

const pathChangeMethod = (path) => {
    return isTokenExist ? path : "*"
}

const elementChangeMethod = (element, path) => {
    let permissionExist = checkPermission(path)
    if(userType === 1 && internalUserPages.includes(path)){
        return isTokenExist  ? <Navigate to="/dashboard" /> : <Navigate to="/" />
    } else {
        return (permissionExist && isTokenExist) ? element : isTokenExist ? <Navigate to="/dashboard" />  : <Navigate to="/" />
    }
    
}

const checkPermission = (path)=> {
    const permission = JSON.parse(userDetails)?.permissions
    const menuPermission = menu.filter((el)=> {
        if(el?.path.toLocaleLowerCase() === path.toLocaleLowerCase()) {
            const readPermission  =  permission?.filter((item) => {
                if(item.activity_id == el.activity_id) {
                    return item._read
                }
            })
            return readPermission && readPermission[0]?._read
        }
    })
    return menuPermission && menuPermission?.[0] ? true : false
}

const currentClickedTypeNumber = localStorage.getItem("currentClickedTypeNumber")

const RoutesConfig = [
    {
        path: "/",
        element: (
            <React.Suspense fallback={ <Loader /> }>
                <LoginLayout />
            </React.Suspense>
        ),
        errorElement: <PageNotFound />,
        children: [
            {
                breadcrumb: "Action Code",
                element: <Login />,
                index: true,
                path: "/",
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                element: <Home />,
                path: "/home"
            },
            {
                element: <SetPassword />,
                index: true,
                path: "/setPassword"
            },
            {
                breadcrumb: "Action Code",
                element: <RegistrationRequest />,
                index: true,
                path: "/registration",
                title: "manageUser"
            },
            {
                breadcrumb: "Error boundary",
                element: <ErrorBoundaryPage />,
                index: true,
                path: "/error-boundary",
                title: "error"
            },
            {
                breadcrumb: "foundationData",
                element: <Home />,
                path: "/home"
            },
            {
                breadcrumb: "foundationData",
                element: <Dashboard />,
                path: "/dashboard"
            }
        ]
    },
    {
        element: (
            <React.Suspense fallback={ <Loader /> }>
                <MainLayout />
            </React.Suspense>
        ),
        errorElement: <PageNotFound />,
        children: [ 
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<ActionCode />, "/actionCode"),
                index: true,
                path: "/actionCode",
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<ParcelCondition />, "/parcelCondtion"),
                index: true,
                path: "/parcelCondtion",
                title: "foundationData"
            },               
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<ParcelContentStatus />, "/parcelContentStatus"),
                index: true,
                path: "/parcelContentStatus",
                title: "foundationData"
            },               
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<RetailerName />, "/retailerName"),
                index: true,
                path: "/retailerName",
                title: "foundationData"
            }, 
            {
                breadcrumb: "foundationData",
                children: [],
                element: elementChangeMethod(<ServiceMaterialAssociation />, "/serviceMaterialAssociation"),
                path: pathChangeMethod("/serviceMaterialAssociation"),
                title: "foundationData"
            },           
            {
                breadcrumb: "foundationData",
                children: [],
                element: elementChangeMethod(<FailureCodeMap />,"/FailureCode"),
                path: pathChangeMethod("/FailureCode"),
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                children: [],
                element: elementChangeMethod(<ExceptionsCode />,"/exceptionsCode"),
                path: pathChangeMethod("/exceptionsCode"),
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                children: [],
                element: elementChangeMethod(<ProductFrom />,"/productFrom"),
                path: pathChangeMethod("/productFrom"),
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<GgIndicator />,"/warrantytype"),
                path: pathChangeMethod("/warrantytype"),
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<PsIndicator />,"/shippingmethod"),
                path: pathChangeMethod("/shippingmethod"),
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                children: [],
                element: elementChangeMethod(<HubList />,"/hubContinents"),
                path: pathChangeMethod("/hubContinents"),
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                children: [],
                element: elementChangeMethod(<HubRegList />,"/hubRegionalContinents"),
                path: pathChangeMethod("/hubRegionalContinents"),
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                children: [],
                element: elementChangeMethod(<HubSubList />,"/hubSubContinents"),
                path: pathChangeMethod("/hubSubContinents"),
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                children: [],
                element: elementChangeMethod(<HubCountry />,"/servicecenternetwork/hubCountry"),
                path: pathChangeMethod("/servicecenternetwork/hubCountry"),
                title: "foundationData"
            },
            {
                breadcrumb: "serviceNetwork",
                children: [],
                element: elementChangeMethod(<PrimaryServiceCenter />,"/service-network"),
                path: pathChangeMethod("/service-network"),
                title: "serviceCenterAddress"
            },
            {
                breadcrumb: "foundationData",
                children: [],
                element: elementChangeMethod(<OrderMinMaxQty />,"/global/orderMinMaxQty"),
                path: pathChangeMethod("/global/orderMinMaxQty"),
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                children: [],
                element: elementChangeMethod(<SalesOrg />,"/salesOrg"),
                path: pathChangeMethod("/salesOrg"),
                title: "foundationData"
            },
            {
                path: pathChangeMethod("/myApprovals"),
                element: elementChangeMethod(<WorkListApproval />, "/myApprovals"),
                title: "Approvals",
                breadcrumb: "myApprovals"
            },
            {
                path: pathChangeMethod("/exceptionApprovers"),
                element: elementChangeMethod(<ExceptionApprovers />,"/exceptionApprovers"),
                title: "foundationData",
                breadcrumb: "Exception Approvers"
            },
            {
                path: pathChangeMethod("/priceList"),
                element: elementChangeMethod(<PriceList />, "/priceList"),
                title: "foundationData",
                breadcrumb: "foundationData"
            },
            {
                path: pathChangeMethod("/foundationData/priceMatrix"),
                element: elementChangeMethod(<PriceMatrix />, "/foundationData/priceMatrix"),
                title: "foundationData",
                breadcrumb: "foundationData",
                index:true
            },
            {
                path: pathChangeMethod("/priceMatrixException"),
                element: elementChangeMethod(<PriceMatrixException />, "/priceMatrixException"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            {
                path: pathChangeMethod("/priceDerivation"),
                element: elementChangeMethod(<PriceDrivation />, "/priceDerivation"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            {
                path: pathChangeMethod("/lumsumPrice"),
                element: elementChangeMethod(<LumsumPrice />, "/lumsumPrice"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            
            {
                path: pathChangeMethod("/masterDataMappingTMC"),
                element: elementChangeMethod(<MasterDataMappingTMC />, "/masterDataMappingTMC"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            {
                path: pathChangeMethod("/listPriceUpload"),
                element: elementChangeMethod(<ListPriceUpload />, "/listPriceUpload"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            {
                path: pathChangeMethod("/nosCorrection"),
                element: elementChangeMethod(<ListPriceforNosCorrection />, "/nosCorrection"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            {
                path: pathChangeMethod("/originalNos"),
                element: elementChangeMethod(<OriginalNOS />, "/originalNos"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            {
                path: pathChangeMethod("pricing/monthlyBookingRate"),
                element: elementChangeMethod(<MonthlyBookingRate />, "pricing/monthlyBookingRate"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            {
                path: pathChangeMethod("pricing/firmRate"),
                element: elementChangeMethod(<FirmRate/>, "pricing/firmRate"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            {
                path: pathChangeMethod("/exchangerate"),
                element: elementChangeMethod(<ExchangeRate />, "/exchangerate"),
                title: "foundationData",
                breadcrumb: "foundationData"
            },
            {
                path: pathChangeMethod("/nosTMCPrice"),
                element: elementChangeMethod(<NOSTMC />, "/nosTMCPrice"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            {
                path: pathChangeMethod("/failure-code-mapped-type-number"),
                element: elementChangeMethod(<FailureCodeMappedTypeNumber />, "/failure-code-mapped-type-number"),
                title: "foundationData",
                breadcrumb: "foundationData"
            },
            {
                path: pathChangeMethod("/service-material/typeno-actioncode-association"),
                element: elementChangeMethod(<ServiceMaterialActionCodeTypeNumberAssociation />, "/service-material/typeno-actioncode-association"),
                title: "foundationData",
                breadcrumb: "foundationData"
            },
            
            {
                path: pathChangeMethod("/countryconfiguration"),
                element: elementChangeMethod(<CountryConfiguration />, "/countryconfiguration"),
                title: "foundationData",
                breadcrumb: "foundationData"
            },
            {
                path: pathChangeMethod("/countryattributeconfig"),
                element: elementChangeMethod(<CountryAttributeConfig />, "/countryattributeconfig"),
                title: "foundationData",
                breadcrumb: "foundationData"
            },
            {
                path: pathChangeMethod("/manageuser"),
                element: elementChangeMethod(<ManageUsers />, "/manageuser"),
                breadcrumb: "userManagement",
                title: "userManagement"
            },
            {
                path: pathChangeMethod("/rolespermission"),
                element: elementChangeMethod(<RolesAndPermission />, "/rolespermission"),
                breadcrumb: "userManagement",
                title: "userManagement"
            },
            {
                path: pathChangeMethod("/registrationform"),
                element: elementChangeMethod(<RegistrationRequest />, "/registrationform"),
                breadcrumb: "userManagement",
                title: "userManagement"
            },
            {
                path: "/product-management/finishedGoods",
                element: elementChangeMethod(<FinishedGoods />, "/product-management/finishedGoods"),
                breadcrumb: "productManagement",
                title: "productManagement",
                index: true
            },
            {
                path: pathChangeMethod("/product-management/type-number"),
                element: elementChangeMethod(<TypeNumber />, "/product-management/type-number"),
                breadcrumb: "productManagement",
                title: "productManagement",
                index: true
            },
            {
                breadcrumb: "productManagement",
                element: elementChangeMethod(<Parts />, "/product-management/parts"),
                index: true,
                path: pathChangeMethod("/product-management/parts"),
                title: "productManagement"
            },
            {
                path: pathChangeMethod("/product-management/associate-parts-to-type"),
                element: elementChangeMethod(<AssociatePartsToType />, "/product-management/associate-parts-to-type"),
                breadcrumb: "productManagement",
                title: "productManagement"
            },
            {
                path: pathChangeMethod("/product-management/associate-fg-to-parts"),
                element: elementChangeMethod(<AssociateFgToParts />, "/product-management/associate-fg-to-parts"),
                breadcrumb: "productManagement",
                title: "productManagement"
            },
            {
                path: pathChangeMethod("/product-management/associate-parts-to-fg"),
                element: elementChangeMethod(<AssociatePartsToFg />, "/product-management/associate-parts-to-fg"),
                breadcrumb: "productManagement",
                title: "productManagement"
            },
            {
                breadcrumb: "productManagement",
                element: elementChangeMethod(<FGAssociationWithCountry />, "/product-management/associate-FG-with-country"),
                index: true,
                path: pathChangeMethod("/product-management/associate-FG-with-country"),
                title: "productManagement"
            },
            {
                breadcrumb: "productManagement",
                element: elementChangeMethod(<BlockTypeNoBulletin/>, "/product-management/block-typeNo-bulletin"),
                index: true,
                path: pathChangeMethod("/product-management/block-typeNo-bulletin"),
                title: "productManagement"
            },
            {
                path: pathChangeMethod("/complaintsWithoutTechnicalDefects"),
                element: elementChangeMethod(<ComplaintsWithoutTechnicalDefects />, "/complaintsWithoutTechnicalDefects"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            {
                path: pathChangeMethod("/allowedMaterials"),
                element: elementChangeMethod(<AllowedMaterials />, "/allowedMaterials"),
                breadcrumb: "foundationData",
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<BlockMaintenance />, "/blockMaintenance"),
                index: true,
                path: "/blockMaintenance",
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<RejectMaintenance />, "/rejectMaintenance"),
                index: true,
                path: "/rejectMaintenance",
                title: "foundationData"
            },
            {
                path: pathChangeMethod("/product-management/article-series"),
                element: elementChangeMethod(<ArticleSeries />, "/product-management/article-series"),
                title: "productManagement",
                breadcrumb: "productManagement"
            },
            {
                path: pathChangeMethod("/product-management/manuel-product-lifecycle-status"),
                element :elementChangeMethod(<ManualProductLifecycleStatus/>, "/product-management/manuel-product-lifecycle-status"),
                title: "productManagement",
                breadcrumb: "productManagement"
            },
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<WarrantyPolicy />, "/policy"),
                index: true,
                path: "/policy",
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<TypeOfRepair />, "/typeOfRepair"),
                index: true,
                path: "/typeOfRepair",
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<ReasonForImpossibility />, "/reasonForImpossibility"),
                index: true,
                path: "/reasonForImpossibility",
                title: "foundationData"
            },
            {
                breadcrumb: "foundationData",
                element: elementChangeMethod(<SampleCollection />, "/SampleCollection"),
                index: true,
                path: "/SampleCollection",
                title: "foundationData"
            }
        ]
    },
    {
        path: "/",
        element: (
            <React.Suspense fallback={ <Loader /> }>
                <PageLayout />
            </React.Suspense>
        ),
        errorElement: <PageNotFound />,
        children: [
            {
                path: pathChangeMethod("/training/details/:trainingid"),
                element: elementChangeMethod(<TrainingDetails />, "/training"),
                breadcrumb: "training//:trainingName",
                isPageLevel: true,
                title: "Training",
                isDynamicBreadCurm: true,
                isShowFromState: true,
                children: []
            },
            {
                path: pathChangeMethod("/training"),
                element: elementChangeMethod(<Training />, "/training"),
                breadcrumb: "training",
                title: "Training",
                isPageLevel: true,
                isDynamicBreadCurm: true
            },
            {
                path: pathChangeMethod("/training/schedule/:trainingid"),
                element: elementChangeMethod(<ScheduleTraining />, "/training"),
                breadcrumb: "training//:trainingName",
                title: "Training",
                isPageLevel: true,
                isDynamicBreadCurm: true,
                isShowFromState: true
            },
            {
                path: pathChangeMethod("/service-network/add-service-center-address"),
                element: elementChangeMethod(<AddNewServiceCenter />, "/service-network/add-service-center-address"),
                breadcrumb: "addNewServiceCenter"
            },
            {
                path: pathChangeMethod("/service-network/edit-service-center-address"),
                element: elementChangeMethod(<EditServiceCenterAddress />, "/service-network/edit-service-center-address"),
                breadcrumb: "editServiceCenter"
            },
            
            {
                path: pathChangeMethod("/product-management/type-number/create-type-number"),
                element: elementChangeMethod(<CreateTypeNumber />, "/product-management/type-number/create-type-number"),
                breadcrumb: "createTypeNumber"
            },
            {
                path: pathChangeMethod("/product-management/type-number/edit-type-number"),
                element: elementChangeMethod(<EditTypeNumber />, "/product-management/type-number/edit-type-number"),
                breadcrumb: "editTypeNumber"
            },
            {
                path: pathChangeMethod("/product-management/finishedGoods/createFinishedGoods"),
                element: elementChangeMethod(<CreateFinishedGoods />, "/product-management/finishedGoods/createFinishedGoods"),
                breadcrumb: "createFG"
            },
            {
                path: pathChangeMethod("/product-management/finishedGoods/editFinishedGoods"),
                element: elementChangeMethod(<EditFinishedGoods />, "/product-management/finishedGoods/editFinishedGoods"),
                breadcrumb: "editFG"
            },
            {
                path: pathChangeMethod("/product-management/parts/create-part-number"),
                element: elementChangeMethod(<CreatePart />, "/product-management/parts/create-part-number"),
                breadcrumb: "createPartNumber",
                index: true
            },
            {
                path: pathChangeMethod("/product-management/parts/edit-part-number"),
                element: elementChangeMethod(<EditPart />, "/product-management/parts/edit-part-number"),
                breadcrumb: "editPartNumber"
            },
            {
                path: pathChangeMethod("/productcatalogue"),
                element: elementChangeMethod(<ProductCatalogue />, "/productcatalogue"),
                breadcrumb: "productCatalogue",
                index: true
            },
            {
                path: pathChangeMethod("/productcatalogue/oralcare"),
                element: elementChangeMethod(<ProductCatalogueCategories />, "/productcatalogue/oralcare"),
                breadcrumb: "oralCare",
                index: true
            },
            {
                path: pathChangeMethod("/productcatalogue/malehairremoval"),
                element: elementChangeMethod(<ProductCatalogueCategories />, "/productcatalogue/malehairremoval"),
                breadcrumb: "maleHairRemoval",
                index: true
            },
            {
                path: pathChangeMethod("/productcatalogue/femalehairremoval"),
                element: elementChangeMethod(<ProductCatalogueCategories />, "/productcatalogue/femalehairremoval"),
                breadcrumb: "femaleHairRemoval",
                index: true
            },
            {
                path: pathChangeMethod("/productcatalogue/advancedSearch"),
                element: elementChangeMethod(<ProductAdvanceSearch />, "/productcatalogue/advancedSearch"),             
                breadcrumb: "advancedSearch",
                index: true
            },
            {
                path: pathChangeMethod("/productcatalogue/searchResult"),
                element: elementChangeMethod(<ProductSearchResult />, "/productcatalogue/searchResult"),             
                breadcrumb: "searchResult",
                index: true
            },
            {
                path: pathChangeMethod("/productcatalogue/:category_name/:id"),
                element: elementChangeMethod(<ProductTypeInstructions />, "/productcatalogue"),
                breadcrumb: `${currentClickedTypeNumber}`,
                isDynamicStaticNumber: true,
                index: true
            },
            {
                path: pathChangeMethod("/foundationData/priceMatrix/calculate"),
                element: elementChangeMethod(<Calculate />, "/foundationData/priceMatrix/calculate"),
                breadcrumb:"calculate"  
            } ,
            {               
                path: pathChangeMethod("/warranty/warranty-management/edit-ticket"),
                element: elementChangeMethod(<EditTicket />, "/warranty/warranty-management/edit-ticket"),
                isexternalUserLink: true,
                breadcrumb: "editTicket"
                
            } 
        ]
    },
    {
        path: "/",
        element: (
            <React.Suspense fallback={ <Loader /> }>
                <PageLayout />
            </React.Suspense>
        ),
        errorElement: <PageNotFound />,
        children: [
            {
                path: pathChangeMethod("/newsandbulletin/:tabName/:newsName/:newsId"),
                element: elementChangeMethod(<NewsAndBulletinDetail />, "/newsandbulletin"),
                breadcrumb: "newsandbulletin//:newsName",
                isPageLevel: true,
                title: ":newsName",
                isDynamicBreadCurm: true,
                children: []
            },
            {
                path: pathChangeMethod("/newsandbulletin"),
                element: elementChangeMethod(<NewsAndBulletin />, "/newsandbulletin"),
                title: "newsandbulletin",
                breadcrumb: "newsBulletin",
                isPageLevel: true,
                isDynamicBreadCurm: false
            },
            {
                path: pathChangeMethod("/regulatory-document/details"),
                element: elementChangeMethod(<RegulatoryDocumentDetails />, "/regulatory-document/details"),
                breadcrumb: "regulatoryDocumentDetails"
            },
            {
                path: pathChangeMethod("/regulatory-document"),
                element: elementChangeMethod(<RegulatoryDocument />, "/regulatory-document"),
                breadcrumb: "regulatoryDocument",
                title: "regulatoryDocument"
            },
            {
                path: pathChangeMethod("/general-extra-instruction/details"),
                element: elementChangeMethod(<GeneralExtraInstructionDocumentDetails />, "/general-extra-instruction/details"),
                breadcrumb: "generalExtraInstructionDetails"
            },
            {
                path: pathChangeMethod("/general-extra-instruction"),
                element: elementChangeMethod(<GeneralExtraInstruction />, "/general-extra-instruction"),
                breadcrumb: "generalExtraInstruction",
                title: "generalExtraInstruction"
            },
            {               
                path: pathChangeMethod("/order"),
                element: elementChangeMethod(<OrderManagement />, "/order"),
                title: "orderManagement",
                breadcrumb: "orderManagement"
            },
            {               
                path: pathChangeMethod("/order/review-order"),
                element: elementChangeMethod(<ReviewOrder />, "/order"),
                breadcrumb: "reviewOrder"
            },
            {               
                path: pathChangeMethod("/order/confirmation"),
                element: elementChangeMethod(<ReviewOrder />,"/order"),
                breadcrumb: "confirmOrder"
            },
            {               
                path: pathChangeMethod("/order/review-order-sc"),
                element: elementChangeMethod(<ReviewOrderSecondarySC />,"/order"),
                breadcrumb: "reviewOrder"
            },
            {               
                path: pathChangeMethod("/order/confirmation-sc"),
                element: elementChangeMethod(<ReviewOrderSecondarySC />,"/order"),
                breadcrumb: "confirmOrder"
            },
            {               
                path: pathChangeMethod("/order/orderUpload"),
                element: elementChangeMethod(<OrderManagement />,"/order"),
                title: "orderManagement",
                breadcrumb: "orderUpload",
                isDynamicBreadCurm: true,
                isShowFromState: true
            },
            {               
                path: pathChangeMethod("/order/orderUpload/review-order"),
                element: elementChangeMethod(<ReviewOrderUpload />, "/order"),
                breadcrumb: "reviewOrder"
            },
            {               
                path: pathChangeMethod("/order/orderUpload/confirmation"),
                element: elementChangeMethod(<ReviewOrderUpload />, "/order"),
                breadcrumb: "confirmOrder"
            },
            {
                path: pathChangeMethod("/order/orderHistory"),
                element: elementChangeMethod(<OrderManagement />, "/order"),
                title: "orderManagement",
                breadcrumb: "orderHistory",
                isDynamicBreadCurm: true,
                isShowFromState: true
            },
            {
                path: pathChangeMethod("/order/orderHistory/orderDetail"),
                element: elementChangeMethod(<OrderDetail />, "/order"),
                breadcrumb: "orderDetail"
            },
            {
                path: pathChangeMethod("/order/orderHistory/sapFeedBack"),
                element: elementChangeMethod(<SAPFeedBack />, "/order"),
                breadcrumb: "SAPFeedBack"
            },
            {
                path: pathChangeMethod("/order/claimForm"),
                element: elementChangeMethod(<OrderClaimForm />,"/order"),
                breadcrumb: "ClaimForm"
            },
            {               
                path: pathChangeMethod("/inventoryStatus"),
                element: elementChangeMethod(<InventoryStatus />,"/inventoryStatus"),
                title: "inventoryStatus",
                breadcrumb: "inventoryStatus"
            },
            {               
                path: pathChangeMethod("/warranty/new-ticket"),
                element: elementChangeMethod(<WarrantyManagement />,"/warranty/new-ticket"),
                title: "warrantyManagement",
                breadcrumb: "warrantyManagement"
            },
            {               
                path: pathChangeMethod("/warranty/ticket-list"),
                element: elementChangeMethod(<WarrantyManagement />,"/warranty/ticket-list"),
                title: "warrantyManagement",
                breadcrumb: "warrantyManagement"
            },
            {               
                path: pathChangeMethod("/warranty/ticket-upload"),
                element: elementChangeMethod(<WarrantyManagement />,"/warranty/ticket-upload"),
                title: "warrantyManagement",
                breadcrumb: "warrantyManagement"
            },
            {               
                path: pathChangeMethod("/warranty/proforma-invoice"),
                element: elementChangeMethod(<WarrantyManagement />,"/warranty/proforma-invoice"),
                title: "warrantyManagement",
                breadcrumb: "warrantyManagement"
            },
            {               
                path: pathChangeMethod("/warranty/sample-collection"),
                element: elementChangeMethod(<WarrantyManagement />,"/warranty/sample-collection"),
                title: "warrantyManagement",
                breadcrumb: "warrantyManagement"
            },
            {               
                path: pathChangeMethod("/warranty/aar-overview"),
                element: elementChangeMethod(<WarrantyManagement />,"/warranty/aar-overview"),
                title: "warrantyManagement",
                breadcrumb: "warrantyManagement"
            },
            {               
                path: pathChangeMethod("/warranty/warranty-management"),
                element: elementChangeMethod(<UnfaulityWarranty />,"/warranty/warranty-management"),
                title: "warrantyManagement",
                breadcrumb: "warrantyManagement"
            },
            {               
                path: pathChangeMethod("/warranty/device-registration"),
                element: elementChangeMethod(<DeviceRegistration />, "/warranty/device-registration"),
                title: "deviceRegistration",
                breadcrumb: "deviceRegistration"
            },
            {               
                path: pathChangeMethod("/warranty/warranty-management/invoice-history"),
                element: elementChangeMethod(<InvoiceHistory />,"/warranty/warranty-management/invoice-history"),
                title: "invoiceHistory",
                breadcrumb: "invoiceHistory"
            },
            {               
                path: pathChangeMethod("/warranty/warranty-management/invoice-history/:customerNumber"),
                element: elementChangeMethod(<InvoiceByCustomerNo />,"/warranty/warranty-management/invoice-history/:customerNumber"),
                title: "invoiceHistory//:customerNumber",
                breadcrumb: "invoiceHistory//:customerNumber",
                isDynamicBreadCurm: true
            },
            {
                path: pathChangeMethod("/warranty/warranty-management/:ticketNumber"),
                element: elementChangeMethod(<PgUserTicketsDetail />,"/warranty/warranty-management/:ticketNumber"),
                title: "warrantyManagement//:ticketNumber",
                breadcrumb: "warrantyManagement//:ticketNumber",
                isPageLevel: true,
                isDynamicBreadCurm: true,
                children: []
               
            },
            {               
                path: pathChangeMethod("/warranty/auto-approval-rules"),
                element: elementChangeMethod(<AutoApprovalRules />,"/warranty/auto-approval-rules"),
                title: "autoApprovalRules",
                breadcrumb: "autoApprovalRules"
            },
            {
                path: pathChangeMethod("/warranty/auto-approval-rules/addedit-autoapproval-rules"),
                element: elementChangeMethod(<AddEditAutoApprovalRules />,"/warranty/auto-approval-rules/addedit-autoapproval-rules"),
                isDynamicStaticNumber: true,
                isShowFromState: true
            },
            {
                path: pathChangeMethod("/PFPReport/pay-for-performance-report/PFPDetailedPage"),
                element: elementChangeMethod(<PFPDetailedReportPage />, "/PFPReport/pay-for-performance-report/PFPDetailedPage"),
                title: "",
                breadcrumb: "performanceDetailedreport"
            },
            {
                path: pathChangeMethod("/pay-for-performance"),
                element: elementChangeMethod(<PayForPerformancePMC />,"/pay-for-performance"),
                title: "payForPerformance",
                breadcrumb: "payForPerformance"
            },
            {
                path: pathChangeMethod("/nos-and-materials-report"),
                element: elementChangeMethod(<NOSMaterials />,"/nos-and-materials-report"),
                title: "nosMaterialsReport",
                breadcrumb: "nosMaterialsReport"
            },
            {
                path: pathChangeMethod("/create-performance-config"),
                element: elementChangeMethod(<CreatePerformanceConfig />,"/create-performance-config"),
                title: "",
                breadcrumb: "createPerformanceConfig"
            },
            {
                path: pathChangeMethod("/edit-performance-config/:newsId"),
                element: elementChangeMethod(<EditPerformanceConfig />,"/edit-performance-config/:newsId"),
                title: "editPerformanceConfig",
                breadcrumb: "editPerformanceConfig"
            },
            {               
                path: pathChangeMethod("/staticReport"),
                element: elementChangeMethod(<StaticReport />, "/staticReport"),
                title: "staticReport",
                breadcrumb: "staticReport"
                
            },
            {
                path: pathChangeMethod("/serviceCenterFactSheet"),
                element: elementChangeMethod(<ServiceCenterFactSheet />, "/serviceCenterFactSheet"),
                title: "serviceCenterFactSheet",
                breadcrumb: "serviceCenterFactSheet"
            },
            {
                path: pathChangeMethod("/PFPReport/pay-for-performance-report"),
                element: elementChangeMethod(<PayForPerformanceReport />,"/PFPReport/pay-for-performance-report"),
                title: "",
                breadcrumb: "performancereport"
            }
        ]
    }
]

export default RoutesConfig
